export default __webpack_public_path__ + "static/media/go4profit.ca9f6107.png";